import * as ReactDOM from 'react-dom'
import ConfigProvider from 'antd/lib/config-provider'
import ru_RU from 'antd/lib/locale-provider/ru_RU'
import * as React from 'react'
import {Provider} from 'react-redux'
import App from './components/app'
import store from './store'

declare const window
declare const ENV_IS_DEV: boolean

export interface GlobalOptionsInterface {
    defaultValues: object
}

window.OsagoExpressCalculator = class OsagoExpressCalculator {
    constructor(nodeId: string, options: GlobalOptionsInterface) {
        ReactDOM.render(
            <ConfigProvider locale={ru_RU}>
                <Provider store={store}>
                    <App initValues={options.defaultValues} />
                </Provider>
            </ConfigProvider>,
            document.getElementById(nodeId)
        )
    }
}
